import { generatePath } from 'react-router-dom';

import { IconButton } from '@components/icon-button';
import { IconInfoSimple } from '@components/icons/info-simple';
import { AvatarNameLink } from '@components/table/renderers';
import { useScopedTranslate } from '@locale/translate';

import { TravellerJourneyListItem } from 'api/types';
import { TableNameCellContainer } from 'components/table-name-cell-container';
import { useCurrentWorkspace } from 'ui/authenticated/main/helpers';
import { routePaths } from 'ui/authenticated/navigation';

import { useTravellerDetailsSidebar } from '../../../travellers/traveller-details-sidebar';
import { TravellerOptionsMenu } from '../../traveller-options-menu';

export const NameCell = ({ row: traveller }: { row: TravellerJourneyListItem }) => {
  const { t } = useScopedTranslate(locale);
  const { workspaceId } = useCurrentWorkspace();
  const showTravellerDetailsSidebar = useTravellerDetailsSidebar();

  return (
    <TableNameCellContainer>
      <AvatarNameLink
        name={traveller.name}
        src={traveller.picture}
        to={generatePath(routePaths.traveller, {
          workspaceId,
          journeyId: traveller.journey,
          travellerId: traveller.shortId,
          '*': null,
        })}
      />
      <IconButton
        variant="ghost-purple"
        size="md"
        icon={<IconInfoSimple />}
        tooltip={t('showTravellerDetails')}
        aria-label={t('showTravellerDetails')}
        onClick={() => {
          showTravellerDetailsSidebar({
            journeyId: traveller.journey,
            travellerId: traveller.shortId,
          });
        }}
      />
      <TravellerOptionsMenu row={traveller} />
    </TableNameCellContainer>
  );
};

const locale = {
  en: {
    showTravellerDetails: 'Show traveller details',
  },
};
